import { useTranslation } from 'react-i18next';
import { groupRankingPrizes, type RankingPrize } from '@/lib/campaigns/rankingCompetition';
import { formatCents } from '@/lib/format';

export function RankingPrizeList({ prizes, currency }: { prizes: readonly RankingPrize[]; currency: string }) {
  const { t } = useTranslation();
  return <ol className="space-y-2">
    {groupRankingPrizes(prizes).map(group => <li key={group.startPlace} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-md bg-muted px-3 py-2 text-sm">
      <div>
        <span className="font-medium">{group.count === 1 ? t('ranking.place', { place: group.startPlace }) : t('ranking.placeRange', { start: group.startPlace, end: group.endPlace })}</span>
        {group.count > 1 && <>{' '}<span className="ml-2 text-muted-foreground">({t('ranking.prizePeople', { count: group.count })})</span></>}
      </div>
      <span className="font-medium tabular-nums">{group.count === 1 ? formatCents(group.amount_cents, currency) : t('ranking.prizeEach', { amount: formatCents(group.amount_cents, currency) })}</span>
    </li>)}
  </ol>;
}
